import { GuidingInfluence } from "@/components/nyla/GuidingInfluence";
import { Vision } from "@/components/nyla/Vision";
import { ImpactStat } from "@/components/nyla/ImpactStat";
import { CtaBanner } from "@/components/nyla/CtaBanner";
import { SEO } from "@/components/nyla/SEO";

const visionJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: "https://nylaairwater.earth/" },
    { "@type": "ListItem", position: 2, name: "Vision", item: "https://nylaairwater.earth/vision" },
  ],
};

export default function VisionPage() {
  return (
    <div data-testid="vision-page" className="pt-14">
      <SEO
        title="Our Vision — Inspired by the Jacobin Cuckoo"
        description="A future where pure water belongs to everyone. Guided by the Jacobin Cuckoo — the bird that drinks only from the sky — Nyla is building the world's most sustainable water brand."
        path="/vision"
        keywords="Jacobin Cuckoo, Nyla vision, sustainable water future, atmospheric water brand story, water conservation India"
        jsonLd={visionJsonLd}
      />
      <GuidingInfluence />
      <Vision />
      <ImpactStat />
      <CtaBanner />
    </div>
  );
}
